import Head from 'next/head'
import clsx from 'clsx'

import { Button } from '@wartek-id/button-v1'
import { Icon } from '@wartek-id/icon-v2'
import { Text } from '@wartek-id/text-v1'

import styles from 'app/KinerjaTimPenilaiPSPage/components/CoachMark/Tooltip.module.css'

import type { WalktourLogic } from 'walktour'

type TooltipProps = WalktourLogic & {
  disablePrev: boolean
  prevLabel?: string
  nextLabel?: string
  closeLabel?: string
}

export function Tooltip({ disablePrev, ...props }: TooltipProps) {
  const {
    allSteps,
    stepIndex,
    prev,
    next,
    close,
    stepContent: {
      customDescriptionRenderer,
      customTitleRenderer,
      title,
      description,
    },
    closeLabel,
    tooltipPosition,
  } = props

  const isLastStep = stepIndex === allSteps.length - 1

  return (
    <>
      <Head>
        {/* Inject style to remove outline */}
        <style>
          {`#walktour-tooltip-container:focus-visible {
            outline: none !important;
          }`}
        </style>
      </Head>

      <div
        className={clsx(styles.tooltip)}
        data-orientation={tooltipPosition?.orientation}
      >
        <div className={styles['tooltip-arrow']}>
          <svg
            width="12"
            height="6"
            viewBox="0 0 12 6"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M6 -5.24537e-07L-9.38456e-07 6L12 6L6 -5.24537e-07Z"
              fill="currentColor"
            />
          </svg>
        </div>

        <div className="relative inset-0">
          <div className="flex flex-col gap-2 p-4 space-y-4 bg-white rounded max-w-80">
            {customTitleRenderer
              ? customTitleRenderer(title, props)
              : title && (
                  <Text variant="heading-sm" className="mb-1">
                    {title}
                  </Text>
                )}
            {customDescriptionRenderer ? (
              customDescriptionRenderer(description, props)
            ) : (
              <Text variant="body">{description}</Text>
            )}

            <div className="flex justify-between gap-2">
              <Button
                size="sm"
                variant="ghost"
                className="!text-black"
                onClick={() => {
                  close()
                }}
              >
                {closeLabel ?? 'Tutup'}
              </Button>

              <div className="flex space-x-2">
                {!disablePrev && stepIndex > 0 && (
                  <Button
                    size="sm"
                    color="white"
                    iconOnly
                    className="!rounded-full !p-4 !border-disabled"
                    onClick={() => prev()}
                  >
                    <Icon>chevron_left</Icon>
                  </Button>
                )}

                {!isLastStep && (
                  <Button
                    size="sm"
                    color="white"
                    iconOnly
                    className="!rounded-full !p-4 !border-disabled"
                    onClick={() => next()}
                  >
                    <Icon>chevron_right</Icon>
                  </Button>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  )
}
